import React, { useContext, useEffect, useState } from 'react';
import * as _ from "lodash";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { RequestContext } from "../../context/RequestContext";
import './request.scss';

const StitchBox = (props) => {
    const { sourceLocation } = useContext(RequestContext);
    const [title, setTitle] = useState(props.title);
    const [data, setData] = useState(props.data);
    const stitchMetadata = _.get(sourceLocation, "stitchMetadata", []);

    useEffect(() => {
        setTitle(props.title)
    }, [props.title]);

    useEffect(() => {
        setData(props.data)
    }, [props.data]);

    const handleDelete = (e) => {
        e.preventDefault();
        props.onDelete(data);
    }

    return (
        <div className="stitchBox">
            <div className="stitchBoxInfo" >
                <div>
                  <h3>{title}</h3>
                </div>
                <div>
                    <IconButton
                        style={{right: 0, bottom: 8}}
                        onClick={handleDelete}
                    >
                        <DeleteIcon />
                    </IconButton> 
                </div>
            </div>
            <div className="stitchBoxInfo">
                {
                    stitchMetadata.map((metadata) => (
                        <div key={metadata.label}>
                            <b>{metadata.label}:</b>
                            <span>{_.get(data, metadata.value)}</span>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default StitchBox;
